import React, { useEffect, useState } from 'react';
import { ArrowRightIcon, FlightIcon, FlightRequiredChangeIcon, FlightTopIcon } from "../../../helper/HwIcon";
import {
    airlineImageFn,
    convertMinutesFn, differenceBetweenTwoDatesWithTime,
    formatDayWiseDateFn,
    formatTimeWithDayAndTimeFn
} from "../../../helper/commonFunction";


const FlightViewDetailsComponent = ({ flights, headerAirportDataCityAndCountry, queryParams }) => {
    const [flightDetails, setFlightDetails] = useState({
        departureFlights: [],
        returnFlights: [],
        multiCityData: {},
    })


    useEffect(() => {
        if (flights?.segments?.length && flights?.tripType === 'COMBO') {
            if (Array.isArray(queryParams?.segments)) {
                let multiCityData = {};
                queryParams?.segments?.forEach((segment, segmentIndex) => {
                    const { fromAirport, toAirport, departDate } = segment;
                    let matchedFlights = [];
                    let collecting = false;
                    for (const flight of flights?.segments || []) {
                        const flightDepartureDate = flight?.departure?.departureTime?.split("T")[0];
                        if ((flight.departure.airportCode === fromAirport || flight?.neareastFromAirport === fromAirport) && flightDepartureDate === departDate) {
                            collecting = true;
                        }
                        if (collecting) {
                            matchedFlights.push(flight);
                            if (flight.arrival.airportCode === toAirport || flight?.neareastToAirport === toAirport) {
                                break;
                            }
                        }
                    }

                    if (matchedFlights.length) {
                        multiCityData[segmentIndex] = {
                            flights: matchedFlights,
                            source: flights?.source
                        };
                    }
                });
                setFlightDetails({
                    ...flightDetails,
                    multiCityData: multiCityData,
                });
            } else {
                const departureFlights = [];
                const returnFlights = [];
                let multiCityData = {};
                let isDeparture = true;
                for (const flight of flights?.segments) {
                    if (isDeparture) {
                        departureFlights.push(flight);
                        if (flight.arrival.airportCode === queryParams?.toAirport || flight?.neareastToAirport === queryParams?.toAirport) {
                            isDeparture = false;
                        }
                    } else {
                        returnFlights.push(flight);
                    }
                }

                setFlightDetails({
                    departureFlights,
                    returnFlights,
                    multiCityData
                })
            }
        }
    }, [flights])



    return (
        <>
            {flights?.tripType === 'COMBO' ?
                Object?.keys(flightDetails?.multiCityData)?.length ? Object?.keys(flightDetails?.multiCityData)?.map((flightIndex) => {
                    let flightData = flightDetails?.multiCityData?.[flightIndex];
                    let flights = flightData?.flights;
                    return (
                        <>
                            <div className="hw-nav--tabPane hw-nav--tabFlightDetails">
                                <ul className="list-unstyled hw-search--innerflight__list ss">
                                    {flights?.length ? flights?.map((flightSegments, flightSegmentsIndex) => {
                                        return (
                                            <>
                                                <li>
                                                    <div className="hw-search--innerflight__listItem">
                                                        <div className="flight-list hw-flight--timeline">
                                                            <div className='hw-flight--listOut hw-flight--segment'>
                                                                <div class="hw-flight--marker">
                                                                    <span class="dot"></span>
                                                                    <span class="line"></span>
                                                                </div>
                                                                <div className='hw-flight--timelineDetails'>
                                                                    <div className='f-timeDate hw-blue'>
                                                                        <span>{formatTimeWithDayAndTimeFn(flightSegments?.departure?.departureTime)}</span>
                                                                    </div>
                                                                    <div className='f-place hw-blue'>
                                                                        <span className='hw-fontBold hw-text18'>{flightSegments?.departure?.city}&nbsp;-&nbsp;</span>
                                                                        <div>{flightSegments?.departure?.country}, {flightSegments?.departure?.airportName} - {flightSegments?.departure?.terminal ? (flightSegments?.departure?.terminal?.includes('Terminal') || flightSegments?.departure?.terminal?.includes('terminal')) ?  flightSegments?.departure?.terminal : ` Terminal ${flightSegments?.departure?.terminal}` : ""}
                                                                        </div>
                                                                    </div>
                                                                    <div className="hw-fontWeight--500 hw-primary my-8">
                                                                        {convertMinutesFn(flightSegments?.duration)}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='hw-flight--listOut hw-flight--segment'>
                                                            <div class="hw-flight--marker">
                                                                <span class="dot"></span>
                                                            </div>
                                                            <div className='hw-flight--timelineDetails'>
                                                                <div className='f-timeDate hw-blue'>
                                                                    <span>{formatTimeWithDayAndTimeFn(flightSegments?.arrival?.arrivalTime)}</span>
                                                                </div>
                                                                <div className='f-place hw-blue'>
                                                                    <span className='hw-fontBold hw-text18'>{flightSegments?.arrival?.city}&nbsp;-&nbsp;</span>
                                                                    <div>{flightSegments?.arrival?.country}, {flightSegments?.arrival?.airportName} - {flightSegments?.arrival?.terminal ? (flightSegments?.arrival?.terminal?.includes('Terminal') || flightSegments?.arrival?.terminal?.includes('terminal')) ? flightSegments?.arrival?.terminal : `Terminal ${flightSegments?.arrival?.terminal}` : ""}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </li>
                                                {(flights?.length > 1 && flights?.length !== flightSegmentsIndex + 1) &&
                                                    <li className="hw-search--innerflight__divider">
                                                        <span />
                                                        <div className="divider-badge">
                                                            <div>{differenceBetweenTwoDatesWithTime(flightSegments?.arrival?.arrivalTime, flights[flightSegmentsIndex + 1]?.departure?.departureTime)} Layover in {flights[flightSegmentsIndex + 1]?.departure?.city}</div>
                                                            <div> <FlightRequiredChangeIcon /> Plane Change</div>
                                                        </div>
                                                        <span /></li>}
                                            </>
                                        )
                                    }) : ''}
                                </ul>
                            </div>
                        </>
                    )
                })
                    : <>
                        <div className="hw-nav--tabPane hw-nav--tabFlightDetails">
                            <ul className="list-unstyled hw-search--innerflight__list ss">
                                {flightDetails?.departureFlights?.length ? flightDetails?.departureFlights?.map((flightSegments, flightSegmentsIndex) => {
                                    return (
                                        <>
                                            <li>
                                                <div className="hw-search--innerflight__listItem">
                                                    <div className="flight-list hw-flight--timeline">


                                                        <div className='hw-flight--listOut hw-flight--segment'>
                                                            <div class="hw-flight--marker">
                                                                <span class="dot"></span>
                                                                <span class="line"></span>
                                                            </div>
                                                            <div className='hw-flight--timelineDetails'>
                                                                <div className='f-timeDate hw-blue'>
                                                                    <span>{formatTimeWithDayAndTimeFn(flightSegments?.departure?.departureTime)}</span>
                                                                </div>
                                                                <div className='f-place hw-blue'>
                                                                    <span className='hw-fontBold hw-text18'>{flightSegments?.departure?.city}&nbsp;-&nbsp;</span>
                                                                    <div>
                                                                        {flightSegments?.departure?.country}, {flightSegments?.departure?.airportName} - {flightSegments?.departure?.terminal ? (flightSegments?.departure?.terminal?.includes('Terminal') || flightSegments?.departure?.terminal?.includes('terminal')) ? flightSegments?.departure?.terminal : `Terminal ${flightSegments?.departure?.terminal}` : ""}
                                                                    </div>
                                                                </div>
                                                                <div className="hw-fontWeight--500 hw-primary my-8">
                                                                    {convertMinutesFn(flightSegments?.duration)}
                                                                </div>
                                                            </div>
                                                        </div>
                                                         <div className='hw-flight--listOut hw-flight--segment'>
                                                        <div class="hw-flight--marker">
                                                            <span class="dot"></span>

                                                        </div>
                                                        <div className='hw-flight--timelineDetails'>
                                                            <div className='f-timeDate hw-blue'>
                                                                <span>{formatTimeWithDayAndTimeFn(flightSegments?.arrival?.arrivalTime)}</span>
                                                            </div>
                                                            <div className='f-place hw-blue'>
                                                                <span className='hw-fontBold hw-text18'>{flightSegments?.arrival?.city}&nbsp;-&nbsp;</span>
                                                                <div>{flightSegments?.arrival?.country}, {flightSegments?.arrival?.airportName} - {flightSegments?.arrival?.terminal ? (flightSegments?.arrival?.terminal?.includes('Terminal') || flightSegments?.arrival?.terminal?.includes('terminal')) ? flightSegments?.arrival?.terminal : `Terminal ${flightSegments?.arrival?.terminal}` : ""}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                            </li>
                                            {(flightDetails?.departureFlights?.length > 1 && flightDetails?.departureFlights?.length !== flightSegmentsIndex + 1) &&
                                                <li className="hw-search--innerflight__divider">
                                                    <span />
                                                    <div className="divider-badge">
                                                        <div>{differenceBetweenTwoDatesWithTime(flightSegments?.arrival?.arrivalTime, flightDetails?.departureFlights[flightSegmentsIndex + 1]?.departure?.departureTime)} Layover in {flightDetails?.departureFlights[flightSegmentsIndex + 1]?.departure?.city}</div>
                                                        <div> <FlightRequiredChangeIcon /> Plane Change</div>
                                                    </div>
                                                    <span /></li>}
                                        </>
                                    )
                                }) : ''}
                            </ul>
                        </div>
                        <div className="hw-nav--tabPane hw-nav--tabFlightDetails">
                            <ul className="list-unstyled hw-search--innerflight__list">
                                {flightDetails?.returnFlights?.length ? flightDetails?.returnFlights?.map((flightSegments, flightSegmentsIndex) => {
                                    return (
                                        <>
                                              <li>
                                            <div className="hw-search--innerflight__listItem">
                                                <div className="flight-list hw-flight--timeline">
                                                    <div className='hw-flight--listOut hw-flight--segment'>
                                                        <div className="hw-flight--marker">
                                                            <span className="dot" />
                                                            <span className="line"/>
                                                        </div>
                                                        <div className='hw-flight--timelineDetails'>
                                                            <div className='f-timeDate hw-blue'>
                                                                <span>{formatTimeWithDayAndTimeFn(flightSegments?.departure?.departureTime)}</span>
                                                            </div>
                                                            <div className='f-place hw-blue'>
                                                                <span className='hw-fontBold hw-text18'>{flightSegments?.departure?.city}&nbsp;-&nbsp;</span>
                                                                <div>{flightSegments?.departure?.country}, {flightSegments?.departure?.airportName} - {flightSegments?.departure?.terminal ? (flightSegments?.departure?.terminal?.includes('Terminal') || flightSegments?.departure?.terminal?.includes('terminal')) ? flightSegments?.departure?.terminal : `Terminal ${flightSegments?.departure?.terminal}` : ""}
                                                                </div>
                                                            </div>
                                                            <div className="hw-fontWeight--500 hw-primary my-8">
                                                                {convertMinutesFn(flightSegments?.duration)}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='hw-flight--listOut hw-flight--segment'>
                                                        <div className="hw-flight--marker">
                                                            <span className="dot"/>
                                                        </div>
                                                        <div className='hw-flight--timelineDetails'>
                                                            <div className='f-timeDate hw-blue'>
                                                                <span>{formatTimeWithDayAndTimeFn(flightSegments?.arrival?.arrivalTime)}</span>
                                                            </div>
                                                            <div className='f-place hw-blue'>
                                                                <span className='hw-fontBold hw-text18'>{flightSegments?.arrival?.city}&nbsp;-&nbsp;</span>
                                                                <div> {flightSegments?.arrival?.country}, {flightSegments?.arrival?.airportName} - {flightSegments?.arrival?.terminal ? (flightSegments?.arrival?.terminal?.includes('Terminal') || flightSegments?.arrival?.terminal?.includes('terminal')) ? flightSegments?.arrival?.terminal : `Terminal ${flightSegments?.arrival?.terminal}` : ""}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                            {(flightDetails?.returnFlights?.length > 1 && flightDetails?.returnFlights?.length !== flightSegmentsIndex + 1) &&
                                                <li className="hw-search--innerflight__divider">
                                                    <span />
                                                    <div className="divider-badge">
                                                        <div>{differenceBetweenTwoDatesWithTime(flightSegments?.arrival?.arrivalTime, flightDetails?.returnFlights[flightSegmentsIndex + 1]?.departure?.departureTime)} Layover in {flightDetails?.returnFlights[flightSegmentsIndex + 1]?.departure?.city}</div>
                                                        <div> <FlightRequiredChangeIcon /> Plane Change</div>
                                                    </div>
                                                    <span /></li>}
                                        </>
                                    )
                                }) : ''}

                            </ul>
                        </div>
                    </>
                : <>
                    <div className="hw-nav--tabPane hw-nav--tabFlightDetails">
                        <ul className="list-unstyled hw-search--innerflight__list">
                            {flights?.segments?.length ? flights?.segments?.map((flightSegments, flightSegmentsIndex) => {
                                return (
                                    <>
                                        <li>
                                            <div
                                                className="hw-search--innerflight__listItem">

                                                <div
                                                    className="flight-list hw-flight--timeline">

                                                    <div className='hw-flight--listOut hw-flight--segment'>
                                                        <div class="hw-flight--marker">
                                                            <span class="dot"></span>
                                                            <span class="line"></span>
                                                        </div>
                                                        <div className='hw-flight--timelineDetails'>
                                                            <div className='f-timeDate hw-blue'>
                                                                <span>{formatTimeWithDayAndTimeFn(flightSegments?.departure?.departureTime)}</span>
                                                            </div>
                                                            <div className='f-place hw-blue'>
                                                                <span className='hw-fontBold hw-text18'>{flightSegments?.departure?.city}&nbsp;-&nbsp;</span>
                                                                <div> {flightSegments?.departure?.country}, {flightSegments?.departure?.airportName} - {flightSegments?.departure?.terminal ? (flightSegments?.departure?.terminal?.includes('Terminal') || flightSegments?.departure?.terminal?.includes('terminal')) ? flightSegments?.departure?.terminal : `Terminal ${flightSegments?.departure?.terminal}` : ""}
                                                                </div>
                                                            </div>
                                                            <div className="hw-fontWeight--500 hw-primary my-8">
                                                                {convertMinutesFn(flightSegments?.duration)}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='hw-flight--listOut hw-flight--segment'>
                                                        <div class="hw-flight--marker">
                                                            <span class="dot"></span>

                                                        </div>
                                                        <div className='hw-flight--timelineDetails'>
                                                            <div className='f-timeDate hw-blue'>
                                                                <span>{formatTimeWithDayAndTimeFn(flightSegments?.arrival?.arrivalTime)}</span>
                                                            </div>
                                                            <div className='f-place hw-blue'>
                                                                <span className='hw-fontBold hw-text18'>{flightSegments?.arrival?.city}&nbsp;-&nbsp;</span>
                                                                <div>{flightSegments?.arrival?.country}, {flightSegments?.arrival?.airportName} - {flightSegments?.arrival?.terminal ? (flightSegments?.arrival?.terminal?.includes('Terminal') || flightSegments?.arrival?.terminal?.includes('terminal')) ? flightSegments?.arrival?.terminal : `Terminal ${flightSegments?.arrival?.terminal}` : ""}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        {(flights?.segments?.length > 1 && flights?.segments?.length !== flightSegmentsIndex + 1) &&
                                            <li className="hw-search--innerflight__divider">
                                                <span />
                                                <div className="divider-badge">
                                                    <div>{differenceBetweenTwoDatesWithTime(flightSegments?.arrival?.arrivalTime, flights?.segments[flightSegmentsIndex + 1]?.departure?.departureTime)} Layover in {flights?.segments[flightSegmentsIndex + 1]?.departure?.city}</div>
                                                    <div> <FlightRequiredChangeIcon /> Plane Change</div>
                                                </div>
                                                <span /></li>}
                                    </>
                                )
                            }) : ''}

                        </ul>
                    </div>
                </>
            }

        </>
    )
}

export default FlightViewDetailsComponent;
